export default __webpack_public_path__ + "static/media/gpay.682e8fe5.svg";